export default "__VITE_ASSET__95lRUCWt__"